<template>
    <div class="lesson-task-marking">
        <loading v-if="isLoading"></loading>
        <div class="lesson-task-marking-header">
            <el-row>
                <el-col :span="6">
                    <h6 class="student-name" v-text="tasksInfo.name || '-'"></h6>
                    <div class="mark-list">
                        <el-select placeholder="请选择" size="small" v-model="curAnnexIndex" @change="annexChange">
                            <el-option v-for="(item, index) in annexList" :key="item.uid" :label="item.name" :value="index"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="text-r" v-if="tasksInfo.canEdit">
                        <p v-if="tasksInfo.isGroup">
                            <el-popover width="300" trigger="click">
                                <div class="marking-menber">
                                    <el-row class="marking-menber-top">
                                        <el-col :span="12">成员成绩</el-col>
                                        <el-col class="text-r" :span="12">
                                            <el-button type="text" size="mini" @click="UD">统一给分</el-button>
                                        </el-col>
                                    </el-row>
                                    <el-row class="marking-menber-item" v-for="member in tasksInfo.members" :key="member.uid">
                                        <el-col :span="12">
                                            <p>
                                                <span v-text="member.nickname"></span>&nbsp;&nbsp;
                                                <el-tag type="info" size="mini" v-if="member.isLoader > 0">组长</el-tag>
                                            </p>
                                            <p v-text="member.username"></p>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-row>
                                                <el-col :span="12" class="text-r">成绩:</el-col>
                                                <el-col :span="12">
                                                    <el-input size="mini" v-model="member.score" placeholder="未批">
                                                    </el-input>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                </div>
                                <el-button type="text" size="mini" slot="reference">小组成绩</el-button>
                            </el-popover>
                        </p>
                        <p class="lesson-task-marking-score" v-else>
                            <b>成绩:</b>
                            <el-input size="small" v-model="tasksInfo.score" :placeholder="tasksInfo.statusText" @change="scoreChange"></el-input>
                        </p>
                        <div class="lesson-task-marking-tools">
                            <div class="lesson-task-marking-tool">
                                <el-button size="small" type="text" v-for="item in toolList" :key="item.name" :class="item.name | toolBtnClass(curTool)" :title="item.text" @click="changeCurTool(item.name)"></el-button>
                            </div>
                            <div class="lesson-task-marking-tool">
                                <el-button class="tool tool-narrow" size="small" type="text" title="缩小" :disabled="scale == minScale" @click="narrow"></el-button>
                                <el-button class="tool tool-enlarge" size="small" type="text" title="放大" :disabled="scale > 3" @click="enlarge"></el-button>
                            </div>
                            <div class="lesson-task-marking-tool">
                                <div class="paf-page-cur">
                                    <el-input class="page-cur" size="small" type="number" min="1" :max="totalPage" v-model="pageNum" @change="handleChange"></el-input>
                                    &nbsp;&nbsp;/&nbsp;&nbsp;{{totalPage}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="pdf-box">
            <div class="pdf-body" id="pdfBody" ref="pdfBody">
                <div class="pdf-wrapper" v-show="!isLoading">
                    <div id="container" ref="pdfContainer" @click="padClick"></div>
                    <div class="annotations-list-uoc" :style="{
                            right: `calc(50% - (${width}px / 2))`
                         }">
                        <div class="annotations-panel" @click="showAnnexList = !showAnnexList">
                            <span class="panelSpan" title="批注列表">
                                <span class="label-counter" v-text="curMarks.length"></span>
                                <span class="panelSpanSpan">
                                    <br />批
                                    <br />注
                                    <br />列
                                    <br />表
                                </span>
                            </span>
                        </div>
                        <div :class="{
                            slimScrollDiv: true,
                            open: showAnnexList
                        }">
                            <ul class="container-anotacions">
                                <li class="annotator-marginviewer-element" v-for="mark in curMarks" :key="mark.id" @mouseenter="handleMouseenter($event, mark.id)" @mouseleave="handleMouseleave($event, mark.id)">
                                    <div class="annotator-marginviewer-text" @click="goMarkPos(mark)">
                                        <img class="annotatoricon" :src="require('@/assets/imgs/'+mark.type+'0.png')" />
                                    </div>
                                    <div class="annotator-marginviewer-footer">
                                        <div class="footerInfo">
                                            <el-row>
                                                <el-col :span="12">
                                                    <span class="label-compartit">{{ mark.type | filterMarkText }}</span>
                                                </el-col>
                                                <el-col class="text-r" :span="12">
                                                    <div v-text="mark.createTime"></div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="annotator-viewer-delete footerDel" align="center" @click="delDomMarkConfirm(mark.id)">
                                            <span class="label">删除</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-btns" ref="pageBtns" v-if="tasksInfo.canEdit">
            <el-row>
                <el-col :span="6" :offset="18">
                    <el-col :span="12">
                        <el-button size="mini" type="primary" :disabled="!tasksInfo.preUid" @click="changeStudent(tasksInfo.preUid)">上个学生</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-button size="mini" type="primary" v-if="tasksInfo.nextUid" @click="changeStudent(tasksInfo.nextUid)">下个学生</el-button>
                        <el-button size="mini" type="warning" v-else-if="!tasksInfo.nextUid">查看详情</el-button>
                    </el-col>
                </el-col>
            </el-row>  
        </div>
        <div class="annotation-text" v-if="curTool === 'annotation' && curAnnexInfo" :style="{
                 left: curAnnexInfo.l,
                 top: curAnnexInfo.t
             }">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入内容" v-model="curAnnexInfo.text"></el-input>
            <div class="annotator-controls">
                <el-button size="mini" @click="curAnnexInfo = null">取消</el-button>
                <el-button type="primary" size="mini" @click="drTextSvg">确定</el-button>
            </div>
        </div>
        <el-dialog title="统一给分" width="30%" :visible.sync="uniformDistribution">
            <el-form ref="form" label-width="80px" :model="form" :rules="rules">
                <el-form-item label="小组分数" prop="score">
                    <el-input-number size="small" v-model="form.score" :min="0" label="分数"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="uniformDistribution = false">取 消</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PDFJS from 'pdfjs-dist'
import { TextLayerBuilder } from 'pdfjs-dist/web/pdf_viewer'
import { dragMark, insertMark, insertSvg, insertSvgText, reviewMark } from '@/utils/drag'
import { hasClass, curentTime } from '@/utils/util.js'
import { getTaskAnnexList, setTasksScore, getMaskTasksInfo, getGroupMaskTasksInfo } from '@/api/lab/tasks'
import { getMarkList, addMark, updateMark, delMark } from '@/api/lab/task-mark'
import { getFileUrlByUid } from '@/api/file'
import 'pdfjs-dist/web/pdf_viewer.css'
import Loading from '@/components/common/task-loading'

// 引入pdf.js的字体
const CMAP_URL = 'pdfjs-dist/cmaps/' // https://unpkg.com/pdfjs-dist@2.0.943/cmaps/

PDFJS.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.min.js'

export default {
    data () {
        return {
            isLoading: true,
            score: null, // 成绩
            pdfDoc: null,
            totalPage: 0,
            pageNum: 1,
            container: null,
            scale: 2, // PDF区域的缩放值 默认2倍缩放
            minScale: 0.5,// 最小缩放值
            width: 0,
            height: 0,
            scrollTop: 0,
            curMarks: [], // 当前附件的批注列表
            showAnnexList: false, // 展开批注列表
            annexList: [], // 附件列表
            tasksInfo: {
                name: '',
                statusText: '未批',
                score: null,
                isGroup: false,
                canEdit: false
            },
            curAnnexIndex: 0, // 当前批阅的附件的索引
            curTool: null, // 当前的批阅类型
            curAnnexInfo: null, // 当前批阅详情
            toolList: [
                { name: 'arrow', text: '箭头', icon: 'el-icon-check' },
                { name: 'correct', text: '对', icon: 'el-icon-check' },
                { name: 'error', text: '错', icon: 'el-icon-close' },
                { name: 'righterror', text: '半对', icon: 'el-icon-check' },
                { name: 'doubt', text: '疑问', icon: 'el-icon-question' },
                { name: 'polyline', text: '涂写', icon: 'el-icon-question' },
                { name: 'rect', text: '矩形', icon: 'el-icon-question' },
                { name: 'ellipse', text: '椭圆', icon: 'el-icon-question' },
                { name: 'annotation', text: '批注', icon: 'el-icon-question' },
            ],
            uniformDistribution: false,
            form: {},
            rules: {
                score: [
                    { required: true, message: '请输入分值', trigger: 'blur' }
                ],
            }
        }
    },
    components:{
        Loading
    },
    created () {
        this.init()
        this.listenerFunction()
    },
    filters: {
        filterMarkText: function (type) {
            let typeText = type;
            switch (type) {
                case 'error':
                    typeText = '错误'
                    break;
                case 'correct':
                    typeText = '正确'
                    break;
                case 'doubt':
                    typeText = '疑问';
                    break;
                case 'righterror':
                    typeText = '半对'
                    break;
                case 'arrow':
                    typeText = '箭头'
                    break;
                case 'rect':
                    typeText = '矩形'
                    break;
                case 'ellipse':
                    typeText = '椭圆'
                    break;
                case 'polyline':
                    typeText = '涂鸦'
                    break;
                case 'annotation':
                    typeText = '批注'
                    break;
            }
            return typeText;
        },
        toolBtnClass (toolName, curTool) {
            let oCla = {
                tool: true,
                active: toolName === curTool
            }
            oCla[`tool-${toolName}`] = true
            return oCla
        }
    },
    computed: {
        curAnnex () {
            return this.annexList[this.curAnnexIndex]
        },
        ...mapGetters(['isRefresh'])
    },
    watch: {
        curTool (n) {
            if (n == null) {
                this.$refs.pdfContainer.style.cursor = `auto`
                const svgs = document.getElementsByClassName('svgContainer')
                setTimeout(() => {
                    for (let i = 0; i < svgs.length; i++)
                        svgs[i].style.zIndex = null;
                }, 50)
            } else {
                let cur = 'tuyamove';
                if (['correct', 'error', 'righterror', 'doubt'].contains(n)) {
                    cur = n;
                } else {
                    const svgs = document.getElementsByClassName('svgContainer')
                    setTimeout(() => {
                        for (let i = 0; i < svgs.length; i++)
                            svgs[i].style.zIndex = 999;
                    }, 50)
                }
                this.$refs.pdfContainer.style.cursor = `url(${require(`@/assets/imgs/${cur}.png`)}),auto`
            }
        }
    },
    methods: {
        ...mapActions(["setRefresh"]),
        init () {
            this.getTaskAnnexList()
            this.getTasksInfo()
        },
        UD () {
            this.form = {}
            this.uniformDistribution = true
        },
        submit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.scoreChange(this.form.score)
                    this.uniformDistribution = false
                } else {
                    return false
                }
            })
        },
        /**
         * 保存svg文本信息
         */
        drTextSvg () {
            insertSvgText(this.curAnnexInfo, (entity, shape, rect, delBtn) => {
                this.addMark(entity).then(res => {
                    shape.setAttribute('id', `mark-${res}`)
                    rect.setAttribute("id", `selector-${res}`)
                    delBtn.setAttribute('id', `del-${res}`)
                    shape = null;
                    this.curMarks.push({
                        ...entity,
                        id: res,
                        createTime: curentTime(),
                        type: this.curTool
                    })
                    this.curAnnexInfo = null;
                })
            })
        },
        /**
         * 放大
         */
        enlarge () {
            this.scale += 0.5; // 缩放倍数
            this.container.innerHTML = "";
            this.renderAllPdf();
            this.initMarking()
        },
        /**
         * 缩小
         */
        narrow () {
            if (this.scale <= this.minScale)
                return;
            this.scale -= 0.5; // 缩放倍数
            this.container.innerHTML = "";
            this.renderAllPdf();
            this.initMarking()
        },
        /**
         * 异步展示PDF的内容
         */
        async showPDF (uid) {

            const fileUrl = getFileUrlByUid(uid)       

            this.curMarks = []

            // 中文字体缺失
            PDFJS.cMapUrl = CMAP_URL // include "/"
            PDFJS.cMapPacked = true // set cMapPacked = true to ignore Warning: Ignoring invalid character "121" in hex string

            await PDFJS.getDocument(fileUrl).then(pdf => {
                this.pdfDoc = pdf;
                this.totalPage = pdf.numPages;
                this.container = document.getElementById('container');
                this.renderAllPdf();
            }).catch(() => { // 不是pdf，是图片
                let imgdiv = document.createElement('div');
                imgdiv.setAttribute('class', 'page img-content');
                imgdiv.setAttribute('id', 'page-1');
                imgdiv.setAttribute('style', 'width:900px; height: 900px');
                let img = document.createElement('img');
                img.style.maxWidth = '600px';
                img.src = fileUrl;
                imgdiv.appendChild(img)
                this.container = document.getElementById('container');
                this.container.appendChild(imgdiv);
                // 创建文本图层div
                const textLayerDiv = document.createElement('div');
                const svgDiv = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                this.width = 900
                this.height = 800
                svgDiv.setAttribute('width', '900px');
                svgDiv.setAttribute('height', '800px');
                svgDiv.setAttribute('id', `svgContainer1`)
                svgDiv.setAttribute('class', `svgContainer`)
                textLayerDiv.setAttribute('class', 'textLayer');
                textLayerDiv.appendChild(svgDiv);
                // 将文本图层div添加至每页pdf的div中
                imgdiv.appendChild(textLayerDiv);
            })
            this.initMarking()
        },
        // 渲染所有pdf
        renderAllPdf () {
            for (var i = 1; i <= this.totalPage; i++) {
                this.renderPDF(i);
            }
        },
        /**
         * 分页初始化渲染pdf
         */
        renderPDF (num) {
            let pageDiv;
            this.pdfDoc.getPage(num).then(page => {
                var viewport = page.getViewport(this.scale);
                pageDiv = document.createElement('div');
                pageDiv.setAttribute('id', 'page-' + (page.pageIndex + 1));
                pageDiv.setAttribute('class', 'page');
                this.container.appendChild(pageDiv);
                var canvas = document.createElement('canvas');
                pageDiv.appendChild(canvas);
                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                pageDiv.setAttribute('style', `position: relative;`);

                this.width = viewport.width;
                this.height = viewport.height;
                if (this.$refs.pdfBody) {
                    this.$refs.pdfBody.setAttribute('style', `width: ${viewport.width + 5}px;`);
                }
                if(this.$refs.pageBtns){
                    this.$refs.pageBtns.setAttribute('style', `width: ${viewport.width + 5}px;`);
                }
                // 将页面呈现到画布上
                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                page.render(renderContext).then(() => {
                    return page.getTextContent();
                }).then((textContent) => {
                    // 创建文本图层div
                    const textLayerDiv = document.createElement('div');
                    const svgDiv = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    svgDiv.setAttribute('width', viewport.width);
                    svgDiv.setAttribute('height', viewport.height);
                    svgDiv.setAttribute('id', `svgContainer${num}`)
                    svgDiv.setAttribute('class', `svgContainer`)
                    textLayerDiv.setAttribute('class', 'textLayer');
                    textLayerDiv.appendChild(svgDiv);
                    // 将文本图层div添加至每页pdf的div中
                    pageDiv.appendChild(textLayerDiv);
                    // 创建新的TextLayerBuilder实例
                    var textLayer = new TextLayerBuilder({
                        textLayerDiv: textLayerDiv,
                        pageIndex: page.pageIndex,
                        viewport: viewport
                    });
                    textLayer.setTextContent(textContent);
                    textLayer.render();
                });
            });
        },
        /**
         * 页面改变事件
         */
        handleChange (value) {
            let top = (value - 1) * this.height;
            this.scrollTop = document.querySelector('#app').scrollTop = top
        },
        /**
         * 页面滚动事件
         */
        handleScroll () {
            let scrollTop = document.querySelector('#app').scrollTop || 0
            this.scrollTop = scrollTop
            this.pageNum = parseInt(scrollTop / this.height) + 1 || 1;
        },
        // 获取批阅附件列表
        getTaskAnnexList () {
            getTaskAnnexList(this.$route.params.uid).then(res => {
                this.annexList = res
                this.curAnnexIndex = res.length > 0 ? 0 : null
                if (res.length > 0) {
                    this.showPDF(this.curAnnex.uid);
                }
            })
        },
        getTasksInfo () {
            if (this.tasksInfo.isGroup) {
                getGroupMaskTasksInfo(this.$route.params.uid).then(res => {
                    this.tasksInfo = {
                        ...this.tasksInfo,
                        ...res
                    }
                })
            } else {
                getMaskTasksInfo(this.$route.params.uid).then(res => {
                    if (res.isGroup) {
                        this.$set(this.tasksInfo, 'isGroup', true)
                        this.getTasksInfo()
                    }
                    this.tasksInfo = res
                })
            }
        },
        setTasksScore (score) {
            setTasksScore(this.$route.params.uid, score).then(() => {
                this.setRefresh(true)
                this.$message.success('成绩已修改!')
            })
            
        },
        // 在 作业分数 值改变时触发
        scoreChange (score) {
            this.setTasksScore(score)
        },
        // 当前批阅的附件改变时触发
        annexChange () {
            this.container.innerHTML = "";
            this.showPDF(this.curAnnex.uid);
        },
        /**
         * 修改批注类型
         */
        changeCurTool (tool) {
            this.curTool = this.curTool === tool ? null : tool;
        },
        // 初始化获取批注列表
        initMarking () {
            const { annexId } = this.curAnnex;
            getMarkList(annexId).then(res => {
                this.curMarks = res;
                // 回显批注
                this.$nextTick(() => {
                    setTimeout(() => {
                        reviewMark(this.curMarks, this.tasksInfo.canEdit);
                        this.isLoading = false
                    }, 500)
                })
            })
        },
        getId (domid) {
            return domid.split('-')[1];
        },
        /**
         * 点击添加批注
         */
        padClick (ev) {
            this.curAnnexInfo = null
            if (this.curTool === 'annotation') {
                let pageDom = ev.target || ev.srcElement
                let pageId = pageDom.getAttribute('id')
                if (pageId == null)  return
                let pageNum = Number(pageId.substr('svgContainer'.length))
                let scrollTop = document.querySelector('#app').scrollTop
                // 计算图标的位置
                // let top = ev.clientY + (this.scrollTop - (pageNum - 1) * (this.height + 10)) - 110
                let top = ev.clientY - 110
                let left = (ev.clientX - (document.body.offsetWidth - this.width) / 2)
                let newStr = null
                if(pageNum == 1) {
                    newStr = top + scrollTop
                }else {
                    newStr = top + scrollTop - (pageNum - 1) * (this.height + 10)
                }
                // 绘制svg - text
                this.curAnnexInfo = {
                    type: 'annotation',
                    page: pageNum,
                    pageLeft: left,
                    pageTop: newStr,
                    l: `calc(50% - ${(this.width / 2) - left + 8}px)`,
                    t: `${top}px`,
                    text: ''
                }
            } else {
                this.insertMarkToDom(ev);
            }

        },
        // 添加批注到页面中
        insertMarkToDom (ev) {
            insertMark(this.curTool, this.scrollTop, ev, this.height, this.width, (entity, mark, delBtn) => {
                if (!entity)
                    return;
                this.addMark(entity).then(res => {
                    mark.setAttribute('id', 'mark-' + res)
                    delBtn.setAttribute('id', 'del-' + res)
                    this.curMarks.push({
                        ...entity,
                        id: res,
                        createTime: curentTime(),
                        type: this.curTool
                    })
                })
            })
        },
        // 添加svg批注到页面中
        insertSvgToDom (svgDom) {
            insertSvg(svgDom, this.curTool, (entity, shape, rect, delBtn) => {
                this.addMark(entity).then(res => {
                    shape.setAttribute('id', `mark-${res}`)
                    rect.setAttribute("id", `selector-${res}`)
                    delBtn.setAttribute('id', `del-${res}`)
                    shape = null;
                    this.curMarks.push({
                        ...entity,
                        id: res,
                        createTime: curentTime(),
                        type: this.curTool
                    })
                })
            })
        },
        /**
         * 添加批注
         */
        addMark (mark) {
            const { annexId } = this.curAnnex;
            return addMark({
                type: this.curTool,
                annexId: annexId,
                ...mark
            })
        },
        delDomMarkConfirm (id) {
            this.$confirm('此操作将永久删除该标注, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delDomMark(id);
            }).catch(() => { })
        },
        /**
         * 删除批注
         */
        delDomMark (markId) {
            const markDom = document.getElementById(`mark-${markId}`);
            const selDom = document.getElementById(`selector-${markId}`);
            const delBtn = document.getElementById(`del-${markId}`);
            if (markDom)
                markDom.parentNode.removeChild(markDom);
            if (selDom)
                selDom.parentNode.removeChild(selDom);
            if (delBtn)
                delBtn.parentNode.removeChild(delBtn);

            // 删除标记 - 数据
            const mark = this.curMarks.filter(row => row.id == markId);
            this.curMarks.remove(mark[0])
            // 删除标记 - 数据库
            delMark([markId])
        },
        handleMouseenter (ev, id) {
            let mark = document.getElementById(`mark-${id}`)
            if (mark) {
                mark.classList.add('active')
            }
        },
        handleMouseleave (ev, id) {
            let mark = document.getElementById(`mark-${id}`)
            if (mark) {
                mark.classList.remove('active')
            }
        },
        goMarkPos (row) {
            let mark = document.getElementById(`mark-${row.id}`)
            if (mark) {
                window.scrollTo(0, Number(mark.offsetTop || mark.getAttribute('y2')) + (row.page - 1) * this.height)
            }
        },
        // 切换学生作业
        changeStudent (uid) {
            this.$router.push({
                name: 'lessonTaskMarking',
                params: { uid }
            })
            location.reload(true) // 重新加载页面
        },
        listenerFunction(){
            document.addEventListener('scroll', this.handleScroll, true);
        },
    },
    beforeDestroy () {
        document.removeEventListener("scroll", this.listenerFunction);
    },
    mounted () {
        // window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
        this.$nextTick(() => {
            // 添加滚动事件
            // window.addEventListener('scroll', this.handleScroll)
            const pdfDom = document.getElementById('container')
            // 添加移动事件
            pdfDom.onmousedown = e => {
                let dragging = false;
                e = e || window.event;
                const target = e.target || e.srcElement;
                const className = typeof target.className == 'string' ? target.className : target.className.baseVal
                if (className.indexOf("marking") > -1) {
                    dragMark(target, dragging, this.width, this.height, e, (x, y) => {
                        updateMark({
                            id: this.getId(target.getAttribute('id')),
                            pageTop: `${y}px`,
                            pageLeft: `${x}px`
                        })
                    })
                } else if (className.indexOf("svgContainer") > -1 && this.curTool != 'annotation') { // svg画图
                    this.insertSvgToDom(target)
                }
            }
            // 鼠标移入事件
            pdfDom.onmouseover = e => {
                e = e || window.event;
                // e.preventDefault();
                const target = e.target || e.srcElement
                const domId = target.getAttribute('id')
                if (!domId) return;
                if (domId.indexOf('mark-') > -1) {
                    const id = domId.split('-')[1]
                    const selDom = document.getElementById(`selector-${id}`)
                    const delBtn = document.getElementById(`del-${id}`)
                    setTimeout(() => {
                        if (selDom)
                            selDom.style.display = 'block'
                        if (delBtn)
                            delBtn.style.display = 'block'
                    }, 100)
                }
            }
            pdfDom.onmouseout = e => {
                e = e || window.event;
                const target = e.target || e.srcElement
                const domId = target.getAttribute('id')
                if (!domId) return;
                if (
                    domId.indexOf('selector-') > -1 ||
                    domId.indexOf('mark-') > -1
                ) {
                    const id = this.getId(domId);
                    const selDom = document.getElementById(`selector-${id}`)
                    const delBtn = document.getElementById(`del-${id}`)
                    setTimeout(() => {
                        if (selDom)
                            selDom.style.display = 'none'
                        if (delBtn)
                            delBtn.style.display = 'none'
                    }, 2000)
                }
            }
            /**
             * 添加删除事件
             */
            pdfDom.addEventListener('click', e => {
                const target = e.target || e.srcElement
                if (target && hasClass(target, 'mark-btn')) {
                    e.preventDefault()
                    // 删除指定批注
                    let markId = this.getId(e.target.getAttribute('id'))
                    if (markId) { // 删除对应的元素
                        this.delDomMark(markId)
                    }
                }
            })
        })
    }
}
</script>

<style lang="less">
@import url("~@/assets/css/lesson/exp/marking/main.less");
.lesson-task-marking{
    .page {
        display: block;
    }
    .page-btns{
        padding: 40px 0 20px 0;
        background-color: #fff;
        width: 900px;
        margin:0 auto;
        .el-row{
            text-align: center;
        }
    }
}
</style>

<style lang="less" scoped>
@import url("~@/assets/css/lesson/exp/marking/scoped.less");
</style>
